/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'

/**
 * Loading placeholders shaped like the content they replace. Used instead of
 * spinners for content regions so the layout does not jump when data lands.
 */
const shimmer = css`
  background: linear-gradient(
    90deg,
    ${colors.SECONDARY_300} 25%,
    ${colors.SECONDARY_200} 37%,
    ${colors.SECONDARY_300} 63%
  );
  background-size: 400% 100%;
  animation: skeleton-sweep 1.4s ease infinite;
  border-radius: 4px;

  @keyframes skeleton-sweep {
    0% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0 50%;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`

export const SkeletonText = ({
  width = '100%',
  height = 12,
}: {
  width?: string | number
  height?: number
}) => (
  <span
    css={shimmer}
    data-testid='skeleton-text'
    style={{
      display: 'inline-block',
      width: typeof width === 'number' ? `${width}px` : width,
      height: `${height}px`,
    }}
  />
)

export const SkeletonCircle = ({ size = 32 }: { size?: number }) => (
  <span
    css={shimmer}
    data-testid='skeleton-circle'
    style={{
      display: 'inline-block',
      width: `${size}px`,
      height: `${size}px`,
      borderRadius: '50%',
    }}
  />
)

export const SkeletonRow = ({ height = 38 }: { height?: number }) => (
  <div
    css={shimmer}
    data-testid='skeleton-row'
    style={{ width: '100%', height: `${height}px` }}
  />
)
